module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs-layout', {
    attrs: {
      "breadcrumbs": _vm.crumbs
    }
  }, [_c('blog-page-layout', {
    attrs: {
      "id": _vm.state.id,
      "title": _vm.state.title,
      "text": _vm.state.text,
      "middleThumb": _vm.middleThumb,
      "videos": _vm.videos,
      "view": _vm.state.view,
      "comments": _vm.state.comments,
      "prevId": _vm.state.prev_id,
      "nextId": _vm.state.next_id,
      "articles": _vm.articlesList,
      "event_type": _vm.state.event_type,
      "cop_multi_name": _vm.state.cop_multi_name,
      "isReview": _vm.reviewsBlock
    }
  }, [_c('ReviewsBlock', {
    attrs: {
      "blog": true,
      "title": _vm.reviewTitle,
      "compBtnText": _vm.compBtnText,
      "errorValidationText": _vm.errorValidationText,
      "placeholderText": _vm.placeholderText,
      "moderateText": _vm.moderateText,
      "reviews": _vm.reviews,
      "reviewSuccess": _vm.reviewPopup,
      "closeModal": _vm.closeModal,
      "reviewError": _vm.reviewError,
      "auth": _vm.isAuthorized,
      "userData": _vm.userData,
      "rating": false
    },
    on: {
      "submitReview": _vm.submitReview,
      "closePopup": _vm.closePopup
    }
  })], 1)], 1), _c('extra-layout', {
    attrs: {
      "bg": "gray"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17824629","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/blog/article/component.vue
// module id = c180a03c1a7e3408b7e9
// module chunks = 17